import request from "../utils/request";

export function getMsgType() {
    return request({
        url: '/api/sms/msgType/list',
        method: 'get'
    })
}

export function getMessengerList() {
    return request({
        url: '/api/sms/messenger/list',
        method: 'get'
    })
}
